import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { accessService } from '../../services/central-api/access';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    actingBodyId?: number | null;
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    includeAllOption?: boolean;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
    includeEmptyItem?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: (value: number) => void;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodiesUnitsDropdown({ value, setValue, zIndex, actingBodyId, disabled, required, labelFontSize = 16, labelStyle, includeAllOption, viewStyle, label, form, fieldName, includeEmptyItem }: Props) {
    const [selectableActingBodyUnits, setSelectableActingBodyUnits] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodyUnits(actingBodyId: number) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);

            if (!actingBody.actingBodyUnits) {
                setSelectableActingBodyUnits([]);
            } else {
                setSelectableActingBodyUnits([
                    ...(includeEmptyItem ? [{ value: 0, label: '' }] : []),
                    ...(includeAllOption ? [{ value: 0, label: translate('masculineAll') }] : []),
                    ...actingBody.actingBodyUnits.map((role) => {
                        return {
                            value: role.id || 0,
                            label: role.name
                        };
                    })
                ]);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            getActingBodyUnits(actingBodyId);
        }
    }, [actingBodyId]);


    if (form && fieldName) {
        return <FormDropDownPicker
            labelFontSize={labelFontSize}
            label={label ?? translate('unit')}
            items={selectableActingBodyUnits}
            multiple={false}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                labelFontSize={labelFontSize}
                label={label ?? translate('unit')}
                items={selectableActingBodyUnits}
                multiple={false}
                setValue={(val) => {
                    const resolved = typeof val === 'function' ? val(value) : val;
                    setValue(resolved as number);
                }}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}

export default ActingBodiesUnitsDropdown;
